import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { AtsConversationMessageFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  message: AtsConversationMessageFragment
}

// TODO: move to backend
enum Statuses {
  Opened = 'opened_at',
  Delivered = 'delivered_at',
  Error = 'error_at',
  Sent = 'sent_at',
}

type TinyIcons = React.ComponentProps<typeof Icon.Tiny>['icon']

const statusToIcon: Record<Statuses, TinyIcons> = {
  [Statuses.Opened]: 'check',
  [Statuses.Delivered]: 'check',
  [Statuses.Error]: 'cross',
  [Statuses.Sent]: 'check',
}

const statusToLabel = (status: Statuses) =>
  ({
    [Statuses.Error]: i18n.t('ats.candidates.messages.status.error'),
    [Statuses.Opened]: i18n.t('ats.candidates.messages.status.opened'),
    [Statuses.Delivered]: i18n.t('ats.candidates.messages.status.delivered'),
    [Statuses.Sent]: i18n.t('ats.candidates.messages.status.sent'),
  })[status]

const getMessageStatus = (message: AtsConversationMessageFragment) => {
  const { openedAt, deliveredAt, lastErrorAt, sentAt } = message

  if (openedAt) {
    return Statuses.Opened
  } else if (deliveredAt) {
    return Statuses.Delivered
  } else if (lastErrorAt) {
    return Statuses.Error
  } else if (sentAt) {
    return Statuses.Sent
  }
}

export const MessageStatus = ({ message }: Props) => {
  const [openTooltip, toggleTooltip] = useToggle(false)
  const status = getMessageStatus(message)

  if (!status) return null

  return (
    <Box flexDirection="row" alignItems="center" gap="s6">
      <Box
        borderRadius={{
          all: 'rel1000',
        }}
        background="grey800"
      >
        {status === Statuses.Error ? (
          <Tooltip.ItemList
            attachment="bottom center"
            toggle={toggleTooltip}
            open={openTooltip}
            size="small"
          >
            <Icon.Tiny icon={statusToIcon[status]} />
            <Text.Normal size="200">
              {i18n.t('ats.candidates.messages.status.not_delivered_description')}
            </Text.Normal>
          </Tooltip.ItemList>
        ) : (
          <Icon.Tiny icon={statusToIcon[status]} />
        )}
      </Box>
      <Text.Normal color="grey800" size="200">
        {statusToLabel(status)}
      </Text.Normal>
    </Box>
  )
}
